import { useEffect, useState, useCallback } from 'react';
import client from '../api/client';
import { getCode, setCode, clearCode } from '../api/lionjob';

// REDESIGN — soạn prompt thiết kế từ sản phẩm + phong cách.
// Chạy được ngay không cần key AI: copy prompt dán vào ChatGPT/Gemini/Midjourney.
// Khi backend có OPENAI_API_KEY thì bật thêm nút sinh ảnh thẳng vào kho mockup.
const hdr = () => ({ headers: { 'x-lionjob-code': getCode() }, timeout: 200000 });
const api = {
  styles: () => client.get('/lionjob/redesign/styles', hdr()).then((r) => r.data.data),
  addStyle: (b) => client.post('/lionjob/redesign/styles', b, hdr()).then((r) => r.data),
  prompt: (b) => client.post('/lionjob/redesign/prompt', b, hdr()).then((r) => r.data.data),
  generate: (b) => client.post('/lionjob/redesign/generate', b, hdr()).then((r) => r.data),
  products: (q) => client.get('/lionjob/scraped-products', { params: { limit: 20, q: q || undefined }, ...hdr() }).then((r) => r.data.data),
};

export default function RedesignPage() {
  const [unlocked, setUnlocked] = useState(false);
  const [codeInput, setCodeInput] = useState('');
  const [lockErr, setLockErr] = useState('');
  const [unlocking, setUnlocking] = useState(false);

  const [styles, setStyles] = useState([]);
  const [groups, setGroups] = useState([]);
  const [canGen, setCanGen] = useState(false);
  const [group, setGroup] = useState('all');
  const [styleId, setStyleId] = useState('');

  const [title, setTitle] = useState('');
  const [variant, setVariant] = useState('');
  const [niche, setNiche] = useState('');
  const [extra, setExtra] = useState('');
  const [aspect, setAspect] = useState('1:1');

  const [prompt, setPrompt] = useState('');
  const [imgs, setImgs] = useState([]);
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState('');
  const [pickList, setPickList] = useState([]);
  const [pickQ, setPickQ] = useState('');
  const [showPick, setShowPick] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [newStyle, setNewStyle] = useState({ name: '', promptReady: '', negative: '' });

  const load = useCallback(async () => {
    try {
      const d = await api.styles();
      setStyles(d.rows); setGroups(d.groups); setCanGen(d.canGenerate);
      if (d.rows.length && !styleId) setStyleId(d.rows[0].id);
      setUnlocked(true);
    } catch (e) {
      const m = e.response?.data?.message || e.message || 'Không kết nối được backend';
      if (e.response?.status === 403) { clearCode(); setUnlocked(false); }
      setLockErr(m); setMsg('Lỗi: ' + m);
    }
    // eslint-disable-next-line
  }, []);
  useEffect(() => { if (getCode()) load(); /* eslint-disable-next-line */ }, []);

  async function unlock(e) {
    e?.preventDefault();
    const c = codeInput.trim(); if (!c) { setLockErr('Nhập mã code'); return; }
    setLockErr(''); setCode(c); setUnlocking(true);
    try { await load(); } finally { setUnlocking(false); }
  }

  async function doPrompt() {
    if (!title.trim()) { setMsg('Nhập mô tả sản phẩm hoặc chọn từ kho'); return; }
    setBusy('prompt'); setMsg('');
    try {
      const d = await api.prompt({ productTitle: title, variant, niche, styleId, extra, aspect });
      setPrompt(d.prompt); setImgs([]);
      setMsg('✓ Đã soạn prompt' + (d.canGenerate ? '' : ' — copy dán vào ChatGPT/Gemini để tạo ảnh'));
    } catch (e) { setMsg('Lỗi: ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(''); }
  }
  async function doGenerate() {
    if (!prompt) return;
    setBusy('gen'); setMsg('Đang sinh ảnh… (có thể mất 1–2 phút)');
    try {
      const r = await api.generate({ prompt, size: aspect === '4:5' || aspect === '3:4' ? '1024x1536' : aspect === '16:9' ? '1536x1024' : '1024x1024', n: 1 });
      setImgs([...(r.data?.saved || []).map((s) => s.url), ...(r.data?.remote || [])]);
      setMsg('✓ ' + r.message);
    } catch (e) { setMsg('Lỗi sinh ảnh: ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(''); }
  }
  async function searchProducts() {
    try { const d = await api.products(pickQ); setPickList(d.rows); }
    catch (e) { setMsg('Lỗi tìm sản phẩm: ' + (e.response?.data?.message || e.message)); }
  }
  function pick(p) {
    setTitle(p.productTitle || ''); setVariant(p.variant || ''); setNiche(p.niche || '');
    setShowPick(false); setMsg('✓ Đã lấy sản phẩm từ kho');
  }
  async function addStyle() {
    if (!newStyle.name.trim() || !newStyle.promptReady.trim()) { setMsg('Cần tên và đoạn prompt'); return; }
    try { await api.addStyle(newStyle); setNewStyle({ name: '', promptReady: '', negative: '' }); setShowAdd(false); load(); setMsg('✓ Đã thêm phong cách'); }
    catch (e) { setMsg('Lỗi: ' + (e.response?.data?.message || e.message)); }
  }
  const copy = () => { navigator.clipboard.writeText(prompt); setMsg('✓ Đã copy prompt'); };

  if (!unlocked) {
    return (
      <div className="rd-root"><style>{CSS}</style>
        <div className="rd-lock"><div className="rd-lockCard">
          <div className="rd-lockIco">🦁</div><h2>Redesign</h2>
          <p className="rd-lockSub">Khu vực chỉ dành cho Giám đốc. Nhập mã code để mở.</p>
          <form onSubmit={unlock}>
            <input className="rd-lockInput" type="password" autoFocus placeholder="Mã code" disabled={unlocking}
              value={codeInput} onChange={(e) => setCodeInput(e.target.value)} />
            <button className="rd-btn primary" type="submit" disabled={unlocking} style={{ width: '100%', marginTop: 10 }}>
              {unlocking ? '⏳ Đang kết nối…' : 'Mở khóa'}</button>
          </form>
          {lockErr && <div className="rd-lockErr">⚠ {lockErr}</div>}
        </div></div>
      </div>
    );
  }

  const shown = group === 'all' ? styles : styles.filter((s) => s.group === group);

  return (
    <div className="rd-root"><style>{CSS}</style>
      <div className="rd-head">
        <div>
          <h2>Redesign</h2>
          <div className="rd-sub">{msg || 'Chọn sản phẩm + phong cách → ra prompt thiết kế sẵn dùng.'}</div>
        </div>
        <div className="rd-sp" />
        <span className={'rd-mode ' + (canGen ? 'on' : '')}>
          {canGen ? '⚡ Tự sinh ảnh: BẬT' : '✎ Chế độ soạn prompt (chưa có OPENAI_API_KEY)'}
        </span>
      </div>

      <div className="rd-wrap">
        <div className="rd-left">
          <div className="rd-card">
            <h3>1 · Sản phẩm</h3>
            <div className="rd-row">
              <input className="rd-fld" style={{ flex: 1 }} placeholder="Mô tả sản phẩm…" value={title} onChange={(e) => setTitle(e.target.value)} />
              <button className="rd-btn" onClick={() => { setShowPick(true); searchProducts(); }}>Lấy từ kho</button>
            </div>
            <div className="rd-row" style={{ marginTop: 8 }}>
              <input className="rd-fld" style={{ flex: 1 }} placeholder="Loại SP (Shirt, Mug…)" value={variant} onChange={(e) => setVariant(e.target.value)} />
              <input className="rd-fld" style={{ flex: 1 }} placeholder="Niche" value={niche} onChange={(e) => setNiche(e.target.value)} />
            </div>
          </div>

          <div className="rd-card">
            <h3>2 · Phong cách <span className="rd-cnt">{styles.length}</span></h3>
            <div className="rd-row" style={{ marginBottom: 8 }}>
              <select className="rd-fld" value={group} onChange={(e) => setGroup(e.target.value)}>
                <option value="all">Tất cả nhóm</option>
                {groups.map((g) => <option key={g} value={g}>{g}</option>)}
              </select>
              <button className="rd-btn" onClick={() => setShowAdd((v) => !v)}>＋ Thêm</button>
            </div>
            {showAdd && (
              <div className="rd-add">
                <input className="rd-fld wide" placeholder="Tên phong cách" value={newStyle.name} onChange={(e) => setNewStyle({ ...newStyle, name: e.target.value })} />
                <textarea className="rd-fld wide mono" rows={3} placeholder="Đoạn prompt mô tả phong cách (tiếng Anh)" value={newStyle.promptReady} onChange={(e) => setNewStyle({ ...newStyle, promptReady: e.target.value })} />
                <input className="rd-fld wide" placeholder="Cần tránh (không bắt buộc)" value={newStyle.negative} onChange={(e) => setNewStyle({ ...newStyle, negative: e.target.value })} />
                <button className="rd-btn primary" onClick={addStyle} style={{ marginTop: 6 }}>Lưu phong cách</button>
              </div>
            )}
            <div className="rd-styles">
              {shown.map((s) => (
                <button key={s.id} className={'rd-style' + (styleId === s.id ? ' on' : '')} onClick={() => setStyleId(s.id)}>
                  <b>{s.name}</b>
                  <span>{s.promptReady.slice(0, 84)}…</span>
                  <i>{s.group}{s.usedCount ? ` · dùng ${s.usedCount} lần` : ''}</i>
                </button>
              ))}
            </div>
          </div>

          <div className="rd-card">
            <h3>3 · Tinh chỉnh</h3>
            <textarea className="rd-fld wide" rows={2} placeholder="Yêu cầu thêm, vd: thêm hoạ tiết cờ lê và bánh răng" value={extra} onChange={(e) => setExtra(e.target.value)} />
            <div className="rd-row" style={{ marginTop: 8 }}>
              <span className="rd-lab">Tỉ lệ</span>
              {['1:1', '4:5', '3:4', '16:9'].map((a) => (
                <button key={a} className={'rd-pill' + (aspect === a ? ' on' : '')} onClick={() => setAspect(a)}>{a}</button>
              ))}
              <div style={{ flex: 1 }} />
              <button className="rd-btn primary" onClick={doPrompt} disabled={!!busy}>
                {busy === 'prompt' ? '⏳…' : '✦ Soạn prompt'}</button>
            </div>
          </div>
        </div>

        <div className="rd-right">
          <div className="rd-card" style={{ minHeight: 200 }}>
            <h3>Prompt</h3>
            {!prompt ? <div className="rd-empty">Chọn sản phẩm và phong cách rồi bấm <b>Soạn prompt</b>.</div> : (
              <>
                <pre className="rd-out">{prompt}</pre>
                <div className="rd-row" style={{ marginTop: 10 }}>
                  <button className="rd-btn" onClick={copy}>⧉ Copy</button>
                  <button className="rd-btn primary" onClick={doGenerate} disabled={!canGen || !!busy}
                    title={canGen ? 'Sinh ảnh và lưu vào kho mockup' : 'Cần OPENAI_API_KEY ở backend'}>
                    {busy === 'gen' ? '⏳ Đang sinh…' : '🎨 Sinh ảnh'}</button>
                  {!canGen && <span className="rd-hint">Chưa có key → copy prompt dán vào ChatGPT/Gemini.</span>}
                </div>
              </>
            )}
          </div>
          {imgs.length > 0 && (
            <div className="rd-card">
              <h3>Ảnh vừa sinh — đã lưu vào kho mockup</h3>
              <div className="rd-imgs">{imgs.map((u) => <a key={u} href={u} target="_blank" rel="noreferrer"><img src={u} alt="" /></a>)}</div>
            </div>
          )}
        </div>
      </div>

      {showPick && (
        <div className="rd-modal" onClick={() => setShowPick(false)}>
          <div className="rd-box" onClick={(e) => e.stopPropagation()}>
            <h3>Chọn sản phẩm từ kho</h3>
            <div className="rd-row">
              <input className="rd-fld" style={{ flex: 1 }} placeholder="Tìm theo tên…" value={pickQ}
                onChange={(e) => setPickQ(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && searchProducts()} />
              <button className="rd-btn" onClick={searchProducts}>Tìm</button>
            </div>
            <div className="rd-picks">
              {pickList.map((p) => (
                <div key={p.id} className="rd-pick" onClick={() => pick(p)}>
                  {p.productImage ? <img src={p.productImage} alt="" /> : <div className="rd-noimg" />}
                  <div><b>{p.productTitle}</b><span>{p.variant || '—'} · {p.website}</span></div>
                </div>
              ))}
              {pickList.length === 0 && <div className="rd-empty">Không có sản phẩm nào.</div>}
            </div>
            <button className="rd-btn" style={{ marginTop: 10 }} onClick={() => setShowPick(false)}>Đóng</button>
          </div>
        </div>
      )}
    </div>
  );
}

const CSS = `
.rd-root{color:var(--text);padding-bottom:30px}
.rd-head{display:flex;gap:10px;align-items:flex-start;margin-bottom:14px;flex-wrap:wrap}
.rd-head h2{margin:0;font-size:20px}
.rd-sub{color:var(--muted);font-size:12.5px;margin-top:3px;max-width:70ch}
.rd-sp{flex:1}
.rd-mode{font-size:11.5px;color:var(--muted);border:1px solid var(--border);border-radius:20px;padding:4px 11px}
.rd-mode.on{color:var(--ok);border-color:var(--ok)}
.rd-btn{background:var(--panel);color:var(--text);border:1px solid var(--border);padding:7px 12px;border-radius:9px;cursor:pointer;font-size:13px;white-space:nowrap}
.rd-btn:hover:not(:disabled){border-color:var(--accent)}
.rd-btn:disabled{opacity:.45;cursor:not-allowed}
.rd-btn.primary{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}

.rd-wrap{display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);gap:14px}
@media (max-width:900px){.rd-wrap{grid-template-columns:1fr}}
.rd-left,.rd-right{display:flex;flex-direction:column;gap:14px;min-width:0}
.rd-card{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:13px 15px}
.rd-card h3{margin:0 0 9px;font-size:12px;letter-spacing:.06em;text-transform:uppercase;color:var(--muted)}
.rd-cnt{font-family:var(--font-mono);background:var(--input);border-radius:20px;padding:1px 7px;margin-left:5px}
.rd-row{display:flex;gap:8px;align-items:center;flex-wrap:wrap}
.rd-lab{font-size:10px;letter-spacing:.09em;text-transform:uppercase;color:var(--muted);font-weight:600}
.rd-fld{border:1px solid var(--border);background:var(--input);color:var(--text);font:inherit;font-size:12.5px;padding:7px 10px;border-radius:8px}
.rd-fld.wide{width:100%;margin-bottom:6px}
.rd-fld.mono{font-family:var(--font-mono);font-size:12px;resize:vertical}
.rd-pill{border:1px solid var(--border);background:var(--panel);color:var(--muted);font:inherit;font-size:12px;padding:5px 11px;border-radius:20px;cursor:pointer}
.rd-pill.on{background:var(--accent);border-color:var(--accent);color:#fff;font-weight:600}
.rd-add{border:1px dashed var(--accent);border-radius:9px;padding:10px;margin-bottom:9px}

.rd-styles{display:grid;grid-template-columns:1fr;gap:6px;max-height:290px;overflow:auto}
.rd-style{text-align:left;border:1px solid var(--border);background:var(--input);border-radius:9px;padding:8px 10px;cursor:pointer;font:inherit;color:var(--text);display:flex;flex-direction:column;gap:2px}
.rd-style:hover{border-color:var(--accent)}
.rd-style.on{border-color:var(--accent);box-shadow:0 0 0 1px var(--accent)}
.rd-style b{font-size:12.5px}
.rd-style span{font-size:11px;color:var(--muted);line-height:1.4}
.rd-style i{font-size:10px;color:var(--accent);font-style:normal}

.rd-out{background:var(--input);border:1px solid var(--border);border-radius:9px;padding:11px 12px;font-family:var(--font-mono);font-size:11.5px;line-height:1.6;white-space:pre-wrap;word-break:break-word;max-height:340px;overflow:auto;margin:0}
.rd-empty{color:var(--muted);font-size:12.5px;padding:24px 6px;text-align:center}
.rd-hint{font-size:11.5px;color:var(--muted)}
.rd-imgs{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:8px}
.rd-imgs img{width:100%;border-radius:8px;display:block;border:1px solid var(--border)}

.rd-modal{position:fixed;inset:0;background:rgba(8,11,20,.72);display:flex;align-items:center;justify-content:center;padding:24px;z-index:1000}
.rd-box{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:16px 18px;max-width:620px;width:100%;max-height:84vh;overflow:auto}
.rd-box h3{margin:0 0 10px;font-size:14px}
.rd-picks{margin-top:10px;display:flex;flex-direction:column;gap:6px;max-height:52vh;overflow:auto}
.rd-pick{display:flex;gap:9px;align-items:center;padding:7px;border:1px solid var(--border);border-radius:9px;cursor:pointer}
.rd-pick:hover{border-color:var(--accent)}
.rd-pick img,.rd-noimg{width:40px;height:40px;border-radius:7px;object-fit:cover;background:var(--input);flex:none}
.rd-pick b{display:block;font-size:12.5px}
.rd-pick span{font-size:11px;color:var(--muted)}

.rd-lock{display:flex;justify-content:center;padding:60px 20px}
.rd-lockCard{background:var(--panel);border:1px solid var(--border);border-radius:var(--radius);padding:28px 26px;width:340px;text-align:center}
.rd-lockIco{font-size:38px;line-height:1}.rd-lockCard h2{margin:8px 0 4px}
.rd-lockSub{color:var(--muted);font-size:13px;margin:0 0 16px}
.rd-lockInput{width:100%;background:var(--input);color:var(--text);border:1px solid var(--border);border-radius:10px;padding:10px 12px;font-size:14px;text-align:center;letter-spacing:2px}
.rd-lockErr{color:var(--danger);font-size:12px;margin-top:10px}
`;
